function isIterable(fn) {
  if (!fn) {
    return false;
  }
  return Reflect.has(fn, Symbol.iterator) || Reflect.has(fn, Symbol.asyncIterator);
}
export {
  isIterable
};
//# sourceMappingURL=isIterable.mjs.map